import React from 'react';
import { Hero } from '../components/landing/Hero';
import { PainPoints } from '../components/landing/PainPoints';
import { WhyFailed } from '../components/landing/WhyFailed';
import { Method } from '../components/landing/Method';
import { Includes } from '../components/landing/Includes';
import { Results } from '../components/landing/Results';
import { ForWho } from '../components/landing/ForWho';
import { FAQ } from '../components/landing/FAQ';
import { Testimonials } from '../components/landing/Testimonials';
import { FinalCTA } from '../components/landing/FinalCTA';
import { StickyBar } from '../components/landing/StickyBar';
export function LandingPage() {
  return <div className="min-h-screen bg-stone-50 font-sans text-stone-900 selection:bg-emerald-200 selection:text-emerald-900 pb-20 md:pb-0" data-id="element-241">
      <Hero data-id="element-242" />
      <PainPoints data-id="element-243" />
      <WhyFailed data-id="element-244" />
      <Method data-id="element-245" />
      <Includes data-id="element-246" />
      <Results data-id="element-247" />
      <Testimonials data-id="element-248" />
      <ForWho data-id="element-249" />
      <FAQ data-id="element-250" />
      <FinalCTA data-id="element-251" />
      <StickyBar data-id="element-252" />
    </div>;
}